import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { images } from "../../assets";
import { allColors } from "../../constants";
import { HashLink } from "react-router-hash-link";

const businessLinks = [
  {
    name: "Digital Phone Line",
    link: "/#phone-only",
  },
  {
    name: "Digital Phone & Calls",
    link: "/#phone-only",
  },
  {
    name: "Phone Line",
    link: "/#phone-line",
  },
  {
    name: "Phone & Calls",
    link: "/#phone-line",
  },
  {
    name: "Call Rates & Charges",
    link: "/tariff-guide",
  },
  {
    name: "International Call Rates",
    link: "/tariff-guide",
  },
];

const broadLinks = [
  {
    name: "Fibre Broadband",
    link: "/#broadband-only",
  },
  {
    name: "Superfast Fibre Broadband",
    link: "/#broadband-only",
  },
];

const generalLinks = [
  // {
  //   name: "Tariff Guide",
  //   link: "/tariff-guide",
  // },
  {
    name: "Contact Us",
    link: "/#contact-us",
  },
  {
    name: "About",
    link: "/#about",
  },
  {
    name: "Trustpilot",
    link: "/#trust-pilot",
  },
  {
    name: "T&Cs",
    link: "/terms-&-conditions",
  },
  {
    name: "Privacy Policy",
    link: "/privacy-policy",
  },
];

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        background: allColors.jetBlack,
      }}
    >
      <Container
        sx={{
          maxWidth: { xs: "1050px", sm: "1000px", md: "1100px", xl: "1350px" },
          marginTop: "50px",
          paddingBottom: "50px",
          paddingLeft: "30px",
        }}
      >
        <Box
          sx={{
            width: { xs: "35%", sm: "12%" },
            display: { xs: "flex" },
          }}
        >
          <img
            src={images.webLogoFooterImg}
            style={{
              width: "100%",
              height: "100%",
              cursor: "pointer",
              filter:
                "brightness(0) saturate(100%) invert(92%) sepia(100%) saturate(31%) hue-rotate(62deg) brightness(106%) contrast(109%)",
              marginTop: "20px",
            }}
            onClick={() => navigate("/")}
          />
        </Box>
        <Divider
          sx={{
            width: "100%",
            background: allColors.white,
            margin: { xs: "15px 0 30px", sm: "30px 0" },
            height: "2px",
          }}
        />
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "12px", sm: "14px" },
                fontWeight: "600",
                color: allColors.white,
                marginBottom: "4px",
              }}
            >
              Business Phone
            </Typography>
            {businessLinks.map((page) => (
              <Box style={{ marginBottom: "5px" }}>
                <span>
                  <HashLink
                    style={{ textDecoration: "none" }}
                    smooth
                    to={page.link}
                  >
                    <Typography
                      key={page.name}
                      sx={{
                        textDecoration: "none",
                        fontSize: { xs: "12px", sm: "14px" },
                        fontWeight: "400",
                        color: allColors.white,
                        cursor: "pointer",
                      }}
                    >
                      {page.name}
                    </Typography>
                  </HashLink>
                </span>
              </Box>
            ))}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "12px", sm: "14px" },
                fontWeight: "600",
                color: allColors.white,
                marginBottom: "4px",
              }}
            >
              Business Broadband
            </Typography>
            {broadLinks.map((page) => (
              <Box style={{ marginBottom: "5px" }}>
                <span>
                  <HashLink
                    style={{ textDecoration: "none" }}
                    smooth
                    to={page.link}
                  >
                    <Typography
                      key={page.name}
                      sx={{
                        textDecoration: "none",
                        fontSize: { xs: "12px", sm: "14px" },
                        fontWeight: "400",
                        color: allColors.white,
                        cursor: "pointer",
                      }}
                    >
                      {page.name}
                    </Typography>
                  </HashLink>
                </span>
              </Box>
            ))}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "12px", sm: "14px" },
                fontWeight: "600",
                color: allColors.white,
                marginBottom: "4px",
              }}
            >
              Business Phone & Broadband
            </Typography>
            <Box style={{ marginBottom: "5px" }}>
              <span>
                <HashLink
                  style={{ textDecoration: "none" }}
                  smooth
                  to={"/#phone-broadband"}
                >
                  <Typography
                    sx={{
                      textDecoration: "none",
                      fontSize: { xs: "12px", sm: "14px" },
                      fontWeight: "400",
                      color: allColors.white,
                      cursor: "pointer",
                    }}
                  >
                    Fibre & Phone
                  </Typography>
                </HashLink>
              </span>
            </Box>
            <Box style={{ marginBottom: "5px" }}>
              <span>
                <HashLink
                  style={{ textDecoration: "none" }}
                  smooth
                  to={"/#phone-broadband"}
                >
                  <Typography
                    sx={{
                      textDecoration: "none",
                      fontSize: { xs: "12px", sm: "14px" },
                      fontWeight: "400",
                      color: allColors.white,
                      cursor: "pointer",
                    }}
                  >
                    Superfast Fibre & Phone
                  </Typography>
                </HashLink>
              </span>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            {generalLinks.map((page) => (
              <Box style={{ marginBottom: "5px" }}>
                <span>
                  <HashLink
                    style={{ textDecoration: "none" }}
                    smooth
                    to={page.link}
                  >
                    <Typography
                      key={page.name}
                      sx={{
                        textDecoration: "none",
                        fontSize: { xs: "12px", sm: "14px" },
                        fontWeight: "400",
                        color: allColors.white,
                        cursor: "pointer",
                      }}
                      // onClick={() => navigate(page.link)}
                    >
                      {page.name}
                    </Typography>
                  </HashLink>
                </span>
              </Box>
            ))}
            <Box style={{ marginBottom: "5px" }}>
              <span>
                <a
                  style={{ textDecoration: "none" }}
                  target="_blank"
                  href="https://res.cloudinary.com/dsvhzxotv/raw/upload/v1757344306/uploads/pdfs/1757344305861-820110.pdf"
                >
                  <Typography
                    sx={{
                      textDecoration: "none",
                      fontSize: { xs: "12px", sm: "14px" },
                      fontWeight: "400",
                      color: allColors.white,
                      cursor: "pointer",
                    }}
                  >
                    Energy Complaints
                  </Typography>
                </a>
              </span>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <iframe
              style={{ width: "100%", height: "200px" }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.712648134033!2d-0.14478882364897994!3d51.518487609893604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761ad5966688f5%3A0x7f597ce753ed6230!2s85%20Great%20Portland%20St%2C%20London%20W1W%207LT%2C%20UK!5e0!3m2!1sen!2s!4v1736072388069!5m2!1sen!2s"
            />

            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "12px", sm: "14px" },
                fontWeight: "600",
                color: allColors.white,
                marginBottom: "4px",
              }}
            >
              Trust Business Ltd
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "12px", sm: "14px" },
                fontWeight: "400",
                color: allColors.white,
                marginTop: "4px",
              }}
            >
              85 Great Portland Street, London, England, W1W 7LT (15994771)
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
